
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[categorySlug]",
      function () {
        return require("private-next-pages/products/[categorySlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[categorySlug]"])
      });
    }
  